import { useEffect, useRef } from 'react';

/**
 * Compare two objects by comparing all keys shallowly
 */
export function shallowEqual<T extends Record<string, unknown>>(
  a: T | null | undefined,
  b: T | null | undefined,
): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  for (const key of keys) {
    if (a[key] !== b[key]) return false;
    if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
  }
  return true;
}

/**
 * Similar to useEffect, but only runs when the dependency is not shallow equal.
 */
export function useShallowEffect(
  effect: () => void,
  dependency: Record<string, unknown>,
): void {
  const ref = useRef<Record<string, unknown> | null>(null);
  useEffect(() => {
    if (!shallowEqual(ref.current, dependency)) {
      ref.current = dependency;
      effect();
    }
  });
}
